import React from 'react'
import RegisterForm from './RegisterForm';
import HeroSlider from './HeroSlider';

const RegisterHero = () => {

  const data = [
    {
      image: '../images/register-hero/06.jpg',
      name: 'DressTwin',
    },
    {
      image: '../images/register-hero/05.jpg',
      name: 'DressTwin',
    },
    {
      image: '../images/register-hero/08.jpg',
      name: 'DressTwin',
    },
    {
      image: '../images/register-hero/09.jpg',
      name: 'DressTwin',
    },
    {
      image: '../images/register-hero/10.jpg',
      name: 'DressTwin',
    },
  ];

  return (
    <section className='register-hero-section'>
      <div className='register-hero-container'>
        <div className='register-hero-left'>
          <HeroSlider data={data} />
        </div>
        <div className='register-hero-right'>
          <RegisterForm />
        </div>
      </div>
    </section>
  )
};

export default RegisterHero